var map = {
	"./aa-B.E - Computer Science and Engineering.pdf": 66518,
	"./ab-B.E - Electrical and Electronics Engineering.pdf": 78089,
	"./ac-B.Tech - Information Technology.pdf": 89866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12024;